import type {
    AccommodationQuantityType} from "@@/shared/acquire/accommodation-quantity-types";
import {
    accommodationQuantityTypes,
} from "@@/shared/acquire/accommodation-quantity-types";

type AccommodationQuantities = {
    [key in AccommodationQuantityType]: number;
};

/**
 * Average quantities for each quantity type, if more than one accommodation
 * resource is requested to be booked, we have to split the quantities
 * among the resources available in the group, to check if the quantities
 * are within the capacity of the resources available
 */
const getAverageQuantities = (
    quantities:
        | AccommodationQuantities
        | Map<AccommodationQuantityType, number>,
    requestedResourceQuantity: number,
) => {
    const getQuantity = (key: AccommodationQuantityType) =>
        quantities instanceof Map ? quantities.get(key) ?? 0 : quantities[key];

    const averages = new Map<AccommodationQuantityType, number>();
    for (const quantityType of accommodationQuantityTypes) {
        if (!getQuantity(quantityType)) {
            averages.set(quantityType, 0);
            continue;
        }
        const total = getQuantity(quantityType);
        const avg = Math.ceil(total / requestedResourceQuantity);
        averages.set(quantityType, avg);
    }
    return averages;
};
const getAverageQuantitiesAsObject = (
    quantities:
        | AccommodationQuantities
        | Map<AccommodationQuantityType, number>,
    requestedResourceQuantity: number,
): AccommodationQuantities => {
    const averages = getAverageQuantities(
        quantities,
        requestedResourceQuantity,
    );
    const result = accommodationQuantityTypes.reduce((acc, type) => {
        acc[type] = averages.get(type) ?? 0;
        return acc;
    }, {} as AccommodationQuantities);
    return result;
};

export { getAverageQuantities, getAverageQuantitiesAsObject };
